import './user-cache.scss';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';

import { reportError } from '../../../../submodules/shared/utils/report-error';

// One account's cache block: the account row plus its (previously deeply
// nested table-in-a-cell) record table. Extracted to flatten UserCache.render.
const CacheRecordRow = ({ acct, disabled, onDelete }) => (
    <tbody>
        <tr>
            <td>
                <Button
                    disabled={disabled}
                    className="fa fa-trash"
                    variant="link"
                    data-account_id={acct.id}
                    data-added_date={acct.records[0].added_date}
                    onClick={onDelete}
                />
                {acct.id}
            </td>
        </tr>
        <tr>
            <td>
                <Table>
                    <thead>
                        <tr>
                            {R.map(
                                (k) => (
                                    <th key={k}>{R.replace('_', ' ', k)}</th>
                                ),
                                R.keys(acct.records[0]),
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {R.map(
                            (record) => (
                                <tr key={record.id}>
                                    {R.map(
                                        (key) => (
                                            <td key={key}>{record[key]}</td>
                                        ),
                                        R.keys(record),
                                    )}
                                </tr>
                            ),
                            acct.records,
                        )}
                    </tbody>
                </Table>
            </td>
        </tr>
    </tbody>
);

CacheRecordRow.propTypes = {
    acct: PropTypes.object,
    disabled: PropTypes.bool,
    onDelete: PropTypes.func,
};

class UserCache extends React.Component {
    constructor(props) {
        super(props);

        this.fetchCache = R.bind(this.fetchCache, this);
        this.handleDelete = R.bind(this.handleDelete, this);
        this.getMappedUserCache = R.bind(this.getMappedUserCache, this);

        this.state = {
            disabled: {},
        };

        if (R.isEmpty(props.adminReducer.userCache)) {
            props.fetchUserCache();
        }
    }

    fetchCache() {
        this.props.fetchUserCache();
    }
    handleDelete({ target }) {
        this.setState({
            disabled: R.assoc(target.datasetid, true, this.state.disabled),
        });

        const result = this.props.expireUserCache(target.dataset);
        if (result && typeof result.catch === 'function') {
            result.catch((err) => reportError(err, { feature: 'user-cache', op: 'expireUserCache' }));
        }
    }

    getMappedUserCache() {
        const { userCache } = this.props.adminReducer;

        let lastAccount = null;
        const remapped = [];
        let records = [];

        const pushNewAcct = () => {
            if (!R.isNil(lastAccount)) {
                remapped.push({
                    id: lastAccount,
                    records,
                });
                records = [];
            }
        };

        R.forEach((record) => {
            const accountId = record.account_id;

            if (accountId !== lastAccount) {
                pushNewAcct();
                lastAccount = accountId;
            }
            records.push(R.omit(['account_id'], record));
        }, userCache);
        pushNewAcct();

        return remapped;
    }
    render() {
        const { userCache } = this.props.adminReducer;

        return (
            <div className="user-cache">
                <h2>
                    User Cache
                    <Button className="fa fa-refresh" variant="link" onClick={this.fetchCache} />
                </h2>
                {!R.isEmpty(userCache) && (
                    <Table>
                        <thead>
                            <tr>
                                <th className="account-heading">Account</th>
                            </tr>
                        </thead>
                        {R.map(
                            (acct) => (
                                <CacheRecordRow
                                    key={acct.id}
                                    acct={acct}
                                    disabled={this.state.disabled[acct.id]}
                                    onDelete={this.handleDelete}
                                />
                            ),
                            this.getMappedUserCache(),
                        )}
                    </Table>
                )}
            </div>
        );
    }
}

UserCache.propTypes = {
    adminReducer: PropTypes.object,
    fetchUserCache: PropTypes.func,
    expireUserCache: PropTypes.func,
};

export default UserCache;
